import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { newsClient, newsImageUrl } from "../apiClient/newsClient";
import { useAuth } from "../../gym/auth/useAuth";
import type { NewsPost } from "../types/news.types";

function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
}

export function NewsPage() {
  const { isAdmin } = useAuth();
  const [posts, setPosts] = useState<NewsPost[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void newsClient
      .getPosts()
      .then(setPosts)
      .catch((err) => setError(err instanceof Error ? err.message : "Failed to load news."))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>News</h1>
          <p className="page-sub">Company announcements and updates.</p>
        </div>
        {isAdmin && (
          <Link to="/news/admin" className="btn btn-ghost">
            Manage news
          </Link>
        )}
      </header>

      {error ? (
        <div className="state-panel">
          <p>{error}</p>
        </div>
      ) : isLoading ? (
        <div className="state-panel">Loading…</div>
      ) : posts.length === 0 ? (
        <div className="state-panel">
          <p>No news yet — check back soon.</p>
        </div>
      ) : (
        <div className="news-list">
          {posts.map((p) => (
            <article key={p.id} className="news-card">
              {p.imageBlobName && <img className="news-card-image" src={newsImageUrl(p.id)} alt="" />}
              <div className="news-card-body">
                <span className="news-card-date">{formatDate(p.publishedAt)}</span>
                <h2 className="news-card-title">{p.title}</h2>
                <p className="news-card-text">{p.body}</p>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
